(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  /* === Desktop hover-to-open for dropdown/mega menus (keeps click working) === */
  (() => {
    const mqDesktop = window.matchMedia('(min-width: 990px)');
    const mqHover = window.matchMedia('(hover: hover) and (pointer: fine)');

    let cleanupFns = [];

    function cleanup() {
      cleanupFns.forEach((fn) => fn());
      cleanupFns = [];
    }

    function enableHoverMenus() {
      cleanup();

      const header = document.querySelector('.section-header');
      if (!header) return;

      // Target only the desktop header-menu details dropdowns/mega menus
      header.querySelectorAll('header-menu details').forEach((details) => {
        // Only apply to items that actually contain submenu/mega content
        const hasSubmenu =
          details.querySelector('.header__submenu') ||
          details.querySelector('.mega-menu__content') ||
          details.querySelector('.mega-menu__list') ||
          details.querySelector('.mega-menu__linklist');

        if (!hasSubmenu) return;

        let closeTimer;

        const open = () => {
          window.clearTimeout(closeTimer);

          // Close sibling menus inside the same header-menu (prevents multiple open)
          const menu = details.closest('header-menu');
          if (menu) {
            menu.querySelectorAll('details[open]').forEach((d) => {
              if (d !== details) d.removeAttribute('open');
            });
          }

          details.setAttribute('open', '');
        };

        const close = (delay = 120) => {
          window.clearTimeout(closeTimer);
          closeTimer = window.setTimeout(() => {
            // Don't close if user is tabbing through menu items
            if (details.contains(document.activeElement)) return;
            details.removeAttribute('open');
          }, delay);
        };

        const onMouseEnter = () => open();
        const onMouseLeave = () => close(120);
        const onFocusIn = () => open();
        const onFocusOut = (e) => {
          if (!details.contains(e.relatedTarget)) close(0);
        };
        const onKeyDown = (e) => {
          if (e.key === 'Escape') {
            details.removeAttribute('open');
            details.querySelector('summary')?.focus();
          }
        };

        details.addEventListener('mouseenter', onMouseEnter);
        details.addEventListener('mouseleave', onMouseLeave);
        details.addEventListener('focusin', onFocusIn);
        details.addEventListener('focusout', onFocusOut);
        details.addEventListener('keydown', onKeyDown);

        cleanupFns.push(() => {
          details.removeEventListener('mouseenter', onMouseEnter);
          details.removeEventListener('mouseleave', onMouseLeave);
          details.removeEventListener('focusin', onFocusIn);
          details.removeEventListener('focusout', onFocusOut);
          details.removeEventListener('keydown', onKeyDown);
        });
      });
    }

    function sync() {
      if (mqDesktop.matches && mqHover.matches) enableHoverMenus();
      else cleanup();
    }

    mqDesktop.addEventListener('change', sync);
    mqHover.addEventListener('change', sync);

    // Theme editor: re-bind when section reloads
    document.addEventListener('shopify:section:load', sync);

    sync();
  })();

  } catch(e) { console.error(e); }
})();
})();
